import React from "react";

export const MetricSelect = ({ label, value, options }) => (
  <div className="relative inline-block w-full sm:w-auto">
    <select
      className="w-full sm:w-auto h-8 sm:h-9 px-3 sm:px-4 pr-7 sm:pr-8 rounded-full border border-white/70
                 bg-transparent text-[10px] sm:text-[11px] text-white
                 appearance-none focus:outline-none focus:border-white focus:ring-1 focus:ring-white/50
                 cursor-pointer hover:border-white/90 transition-colors"
      defaultValue={value}
    >
      <option value={value} className="bg-slate-800">{label}</option>
      <option disabled className="bg-slate-800">──────────</option>
      {options.map((opt) => (
        <option key={opt} value={opt} className="bg-slate-800">
          {opt}
        </option>
      ))}
    </select>
    {/* <span className="pointer-events-none absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 text-[8px] sm:text-[9px] text-white">
      ▼
    </span> */}
  </div>
);
